/**
 * 접수종료 리뷰 지도 (/m/map/review-order-match — FullFrame) — 현장·수주자·내 위치와 매칭 단계 도움말
 * ($j.Pages.Mobile.ReviewMap / body data-page-name="ReviewMap")
 */
export default class ReviewMap {
    initialize() {
        const D = JSON.parse(document.getElementById('page-data')?.textContent || '{}');   // 서버 값 (#page-data)

        var worker_level = D.worker_level;
        var workerMsg = D.workerMsg;
        var workerSosok = D.workerSosok;
        var my_level = D.my_level;
        var myMsg = D.myMsg;
        var mySosok = D.mySosok;
        var workerCharsoo = D.workerCharsoo; // 합성 사다리 배지 매칭용 차수
        var myCharsoo = D.myCharsoo;
        var baseSosok = D.baseSosok;
        var defaultMatchTab = D.defaultMatchTab; // 도움말 기본 노출 탭
        var orderMatchVer = D.orderMatchVer;       // 이 오더의 매칭 버전 (도움말 조회 기준)
        var orderMatchGrade = D.orderMatchGrade; // 이 오더의 -6차 등급방식 (rank 면 합성 사다리)
        var matchHelpData = null;                     // 도움말 데이터 캐시 (1회만 fetch)
        var baseGps = D.baseGps;
        var workerGps = D.workerGps;
        var myGps = D.myGps;
        var map;
        var shape = {coords: [1, 1, 1, 20, 18, 20, 18 , 1],type: 'poly'};
        var markers = [];
        var bounds ;
        var mapCanvas;
        var start_point;   // 옛 인라인에선 선언 없이 대입해 전역이 됐다 — 모듈(strict)에선 선언해야 한다

        // function checkdcode(tar){
        //     var cc = tar.value;
        //     document.location.href="map_order_person_show.php?chordernum=" + chordernum + "&dirvernum=" + cc;
        // }
        // function closeBack(url){
        //     var obj = document.getElementById("maPmainGetTOp");
        //     var nn = document.location.href;
        //
        //     if( obj ){
        //         parent.document.location.href=url;
        //     }else{
        //         parent.closeMapDoumOrder();
        //     }
        // }
        // 느낌표 아이콘 / 풍선(수주자·내위치) 탭 → 매칭 단계 도움말 (BottomSheet).
        // focus: 'worker' | 'me' → 열릴 때 해당 단계 행으로 스크롤. 내용은 JS 가 ajax JSON 받아 렌더.
        function showinfo(focus){
            if (!window.$j || !$j.Ui || !$j.Ui.BS) { alert('도움말을 표시할 수 없습니다.'); return; }
            if (matchHelpData) { openMatchHelp(focus); return; }
            $.getJSON('/m/ajax/map/match-level-help?ver=' + orderMatchVer + '&grade=' + orderMatchGrade)
                .done(function(res){ matchHelpData = res; openMatchHelp(focus); })
                .fail(function(){ alert('도움말을 불러오지 못했습니다.'); });
        }

        function openMatchHelp(focus){
            var types = (matchHelpData && matchHelpData.types) || [];
            if (!types.length) { alert('도움말 데이터가 없습니다.'); return; }
            var activeKey = defaultMatchTab;
            if (!types.some(function(t){ return t.key === activeKey; })) activeKey = types[0].key;

            $j.Ui.BS.open({
                target: {
                    init: function(){
                        var $c = $('#' + this.id);
                        var tabs = types.map(function(t){
                            return '<button type="button" class="mhelp-tab" data-tab="' + t.key + '">' + mhelpEsc(t.label) + '</button>';
                        }).join('');
                        $c.html('<div class="mhelp"><div class="mhelp-tabs">' + tabs + '</div><div class="mhelp-body"></div></div>');
                        renderMatchPane($c, types, activeKey, focus);
                        $c.off('click.mhelp').on('click.mhelp', '.mhelp-tab', function(){
                            renderMatchPane($c, types, $(this).data('tab'));
                        });
                    }
                },
                fixedHeight: true
            });
            $j.Ui.BS.setTitle('매칭 단계 안내');
        }

        function renderMatchPane($c, types, key, focus){
            var t = types.filter(function(x){ return x.key === key; })[0];
            if (!t) return;
            $c.find('.mhelp-tab').removeClass('sel');
            $c.find('.mhelp-tab[data-tab="' + key + '"]').addClass('sel');

            var $body = $c.find('.mhelp-body');
            // 탭 전환 재초기화 — 기존 DataTable 인스턴스 정리 후 DOM 교체
            var $old = $body.find('table.mhelp-table');
            if ($old.length && $.fn.DataTable && $.fn.DataTable.isDataTable($old)) {
                $old.DataTable().destroy();
            }

            // 이 오더의 타입 탭에서만 수주자·본인 단계를 표시
            var isOrderTab = (key === defaultMatchTab);
            var workerLvl = parseInt(worker_level, 10);
            var myLvl = parseInt(my_level, 10);
            // 합성 사다리(등급표 미시딩 세대)는 lvl 이 동적이라 대조가 안 맞음 → 차수로 매칭.
            // 서버가 rows[].charsoo 를 실어 보내면 합성본이라는 뜻.
            var byCharsoo = !!((t.rows || []).length && t.rows[0].charsoo !== undefined);
            var rows = (t.rows || []).map(function(r){
                var hitWorker = byCharsoo
                    ? (workerCharsoo !== '' && parseInt(workerCharsoo, 10) === r.charsoo)
                    : (workerLvl === r.lvl);
                var hitMe = byCharsoo
                    ? (myCharsoo !== '' && parseInt(myCharsoo, 10) === r.charsoo)
                    : (myLvl === r.lvl);
                var badge = '';
                if (isOrderTab && hitWorker) badge += '<span class="mhelp-mark mhelp-mark-worker">수주자</span>';
                if (isOrderTab && hitMe)     badge += '<span class="mhelp-mark mhelp-mark-me">나</span>';
                return '<tr class="' + (badge ? 'mhelp-hit' : '') + '"><td class="mhelp-lvl">' + r.lvl + '</td>' +
                       '<td class="mhelp-memo">' + badge + mhelpEsc(r.memo) + '</td></tr>';
            }).join('');
            var html =
                '<div class="mhelp-desc">' +
                '<p class="mhelp-summary">' + mhelpEsc(t.summary || '') + '</p>' +
                (t.order ? '<p class="mhelp-order"><span class="mhelp-order-tit">발송 순서</span> ' + mhelpEsc(t.order) + '</p>' : '') +
                '</div>' +
                '<table class="mhelp-table display compact" style="width:100%">' +
                '<thead><tr><th>단계</th><th>설명</th></tr></thead>' +
                '<tbody>' + rows + '</tbody></table>';
            $body.html(html);
            $body.scrollTop(0);

            if ($.fn.DataTable) {
                $body.find('table.mhelp-table').DataTable({
                    paging: false,
                    info: false,
                    lengthChange: false,
                    ordering: false,
                    autoWidth: false,
                    searching: false,
                    language: {
                        emptyTable: '데이터가 없습니다'
                    }
                });
            }

            // focus(수주자/내위치) 우선, 없으면 첫 강조행을 화면 중앙으로 스크롤
            var hitEl = null;
            if (focus === 'worker')  hitEl = $body.find('.mhelp-mark-worker').closest('tr')[0];
            else if (focus === 'me') hitEl = $body.find('.mhelp-mark-me').closest('tr')[0];
            if (!hitEl) hitEl = $body.find('tr.mhelp-hit')[0];
            if (hitEl && hitEl.scrollIntoView) {
                try { hitEl.scrollIntoView({block:'center'}); } catch(e) { hitEl.scrollIntoView(); }
            }
        }

        function mhelpEsc(s){
            return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
                return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
            });
        }
        // function showtipye(n){
        //     document.getElementById("imgsam1").style.display="none";
        //     document.getElementById("imgsam2").style.display="none";
        //     document.getElementById("imgsam3").style.display="none";
        //     document.getElementById("tdsam1").style.backgroundColor="#FFFFFF";
        //     document.getElementById("tdsam2").style.backgroundColor="#FFFFFF";
        //     document.getElementById("tdsam3").style.backgroundColor="#FFFFFF";
        //     var obj = document.getElementById("imgsam" + n);
        //     obj.style.display="block";
        //     document.getElementById("tdsam" + n).style.backgroundColor="#538ED5";
        // }

        // function showMore(){
        //     var ss = parseInt(document.getElementById('infoss').style.height,10);
        //     if( ss < 500){
        //         document.getElementById('infoss').style.height="900px";
        //     }else{
        //         document.getElementById('infoss').style.height="200px";
        //     }
        // }

        function initPage() {
            var hhh = $(window).height();
            var infoss = document.getElementById("infoss");
            var eaorderMap = document.getElementById("eaorderMap");
            var offsets1 = infoss.getBoundingClientRect();
            // var offsets2 = eaorderMap.getBoundingClientRect();
            var hx = parseInt( offsets1.bottom - offsets1.top);
            var hgo = parseInt(hhh - hx - 20);
            eaorderMap.style.height=hgo + "px";
            var imageSize ,imageOption,markerImage;
            markers = [];
            const bGps = baseGps.split(",");
            start_point = new kakao.maps.LatLng(bGps[0].trim(), bGps[1].trim()) ;
            var mapContainer = document.getElementById('eaorderMap');
            var hh = $(window).height();
            mapContainer.style.height=hh +"px";
            var mapOption = { center:start_point , level:5 };
            map = new kakao.maps.Map(mapContainer, mapOption);
            var bounds = new kakao.maps.LatLngBounds();
            imageSize = new kakao.maps.Size(30, 50);
            imageOption = {offset: new kakao.maps.Point(20, 50)};
            var imageSrc = '/img/m/gpsicon_red_01.png';
            markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize, imageOption);
            // kakao.maps.event.addListener(map, 'dragend', function() {
            // });

            // 확대 레벨 제한 설정
            var zoomControl = new kakao.maps.ZoomControl();
            map.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);

            ///////////////////////////////////
            // 현장위치
            if( baseGps.length>10) {
                var iwContent = `<div style='text-align:center;width:100%;color:red;;overflow:hidden;font-size:12px; padding:5px' did='A1'><font color=blue>현장</font><br> ${baseSosok}</div>`;
                var iwPosition = new kakao.maps.LatLng(bGps[0].trim(), bGps[1].trim());
                var infowindow = new kakao.maps.InfoWindow({position: iwPosition, content: iwContent});
                var marker = new kakao.maps.Marker({position: iwPosition});
                marker.setMap(map);
                infowindow.open(map, marker);
                bounds.extend(iwPosition);
            }

            // 수주자와 내위치가 동일위치인지 체크
            var is_same=false; if( workerGps==myGps ) is_same=true;

            ///////////////////////////////////
            // 수주자의 위치
            if( workerGps && workerGps.length>10 ){
                var worker_title = "수주자 ("+workerSosok+")<br>" + worker_level + "차 ("+workerMsg+")";
                if( is_same ) worker_title += "<br><br>내위치("+mySosok+")<br>" + my_level + "차 ("+myMsg+")";

                const wGps = workerGps.split(",");
                iwPosition = new kakao.maps.LatLng(wGps[0].trim(),wGps[1].trim());
                iwContent = "<div data-help='worker' style='cursor:pointer;width:100%;text-align:center;color:blue;overflow:hidden;font-size:12px; padding:5px'  dtype='b'  did='A5'>"+worker_title+ "<br><span style='font-size:10px;color:#1e88e5'>탭하면 단계 안내 ▸</span></div>";
                infowindow = new kakao.maps.InfoWindow({position : iwPosition, content : iwContent });
                marker = new kakao.maps.Marker({position: iwPosition});
                marker.setMap(map);
                infowindow.open(map, marker);
                bounds.extend(iwPosition);
            }

            ///////////////////////////////////
            // 조회자(본인)의 위치
            if( myGps && myGps.length>10 && !is_same ){
                const mGps = myGps.split(",");
                iwPosition = new kakao.maps.LatLng(mGps[0].trim(),mGps[1].trim());
                iwContent = "<div data-help='me' style='cursor:pointer;width:100%;text-align:center;overflow:hidden;font-size:12px; padding:5px'  did='A6'>내위치 ("+mySosok+")<br>" + my_level + "차 ("+myMsg+")<br><span style='font-size:10px;color:#1e88e5'>탭하면 단계 안내 ▸</span></div>";
                infowindow = new kakao.maps.InfoWindow({position : iwPosition, content : iwContent });
                marker = new kakao.maps.Marker({position: iwPosition});
                marker.setMap(map);
                infowindow.open(map, marker);
                bounds.extend(iwPosition);
            }

            map.setBounds(bounds);
            map.relayout();
            // check_Sises();
        }

        function initHandler(){
            // 지도 이벤트 리스너 등록
            kakao.maps.event.addListener(map, 'zoom_changed', function() {
                var minLevel = 7; // 최소 확대 레벨
                var maxLevel = 13; // 최대 확대 레벨

                var currentLevel = map.getLevel();
                console.log(currentLevel);

                // 최소 레벨보다 작으면 최소 레벨로, 최대 레벨보다 크면 최대 레벨로 설정
                if (currentLevel < minLevel) {
                    map.setLevel(minLevel);
                } else if (currentLevel > maxLevel) {
                    map.setLevel(maxLevel);
                }
            });
        }

        // function check_Sises(){
        //     var obj = document.getElementById("eaorderMap");
        //     var hh = $(window).height();
        //     obj.style.height=hh +"px";
        //     var inputs = obj.getElementsByTagName("ul");
        //     for (var i=0; i < inputs.length ; i++ ){
        //         if ( inputs[i].id == "txtt"){
        //             var st1 = inputs[i].parentNode.parentNode;
        //             var sttop = inputs[i].parentNode.parentNode.parentNode;
        //             var rt = sttop.getBoundingClientRect();
        //             st1.style.width = "120px";
        //             sttop.style.width = "120px";
        //         }
        //     }
        // }

        // 느낌표 아이콘·풍선(수주자·내위치) → 도움말, ✕ → 창 닫기 (옛 onclick)
        // 풍선은 카카오 InfoWindow 안이라 지도가 전파를 막을 수 있다 → 캡처 단계에서 받는다
        document.addEventListener('click', (e) => {
            const el = e.target.closest && e.target.closest('[data-help]');
            if (el) showinfo(el.dataset.help || undefined);
        }, true);
        $(document).on('click', '[data-rv="close"]', () => $j.Ui.FullFrame.parent().close('maporderstatusshow'));

        $(function(){
            initPage();
            initHandler();
        });


    }
}
